module.exports = __webpack_public_path__ + "img/landing_application.6c8b8f8d.svg";